import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Override the per-row template on the Feed element: when set, each
// SmartFeed item is rendered by mounting the picked DynamicComponent
// (type=component) from the current destination instead of the
// hardcoded entity-type → card-class lookup the legacy Feed uses.
//
// Reuses the REFERENCED_COMPONENT_PICKER inspector tool (same picker as
// DynamicComponentElement's referenced-component-id) — the DC list is
// scoped to the destination's standard-components feed, so an author
// can pick any of their seeded cards (StoryCard, EventCard, …) without
// leaving the inspector.
export default class FeedRowComponentId extends BaseOption {
  static userInterfaceComponent = {
    label: "Row Template Component",
    component: inspectorTools.REFERENCED_COMPONENT_PICKER,
    props: {},
  };

  static defaultValue = 0;
}
